import ChargerModule from 'components/chargerModule';
import DownloadUploadOrdersModule from './DownloadUploadOrdersModule';

const DownloadUploadOrders = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <DownloadUploadOrdersModule />
    </ChargerModule>
  );
};

export default DownloadUploadOrders;